import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaSignOutAlt, FaUser, FaUserCircle } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const roles = localStorage.getItem("roles");
    setIsLoggedIn(!!token);

    if (roles) {
      try {
        setUserRoles(JSON.parse(roles));
      } catch (e) {
        setUserRoles(Array.isArray(roles) ? roles : [roles]);
      }
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("roles");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    setIsLoggedIn(false);
    navigate("/login");
  };

  const handleProfileNavigation = () => {
    if (userRoles.includes('ROLE_ADMIN')) {
      navigate('/dashboard');
    } else {
      navigate('/profile');
    }
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        {/* ✅ Logo outside nav so it stays visible on mobile */}
        <NavLink to="/" className="logoo1">
          <img src="/images/logo.png" alt="PAPADAM Logo" style={{ height: '60px' }} />
        </NavLink>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <div className="main-links">
            <NavLink to="/booking" className="reserve-link">Reservierung</NavLink>
            <NavLink to="/about" className="nav-link">ÜBERUNS</NavLink>
            <NavLink to="/menu" className="nav-link">SPEISEKARTE</NavLink>

            <NavLink to="/" className="logo ">
            <img src="/images/logo.png" alt="PAPADAM Logo" />
          </NavLink>


            <NavLink to="/opening-hours" className="nav-link">ÖFFNUNGSZEITEN</NavLink>
            <NavLink to="/contact" className="nav-link">KONTAKT</NavLink>
          </div>
        </nav>

        {/* Desktop Login/Profile Icon */}
        <div className="login-icon">
          {isLoggedIn ? (
            <>
              <FaUserCircle
                size={28}
                title={userRoles.includes('ROLE_ADMIN') ? 'Admin Dashboard' : 'User Profile'}
                onClick={handleProfileNavigation}
                style={{ cursor: 'pointer', color: '#dc3545' }}
              />
              <FaSignOutAlt
                size={24}
                title="Logout"
                onClick={handleLogout}
                style={{ cursor: 'pointer', color: '#6c757d', marginLeft: '10px' }}
              />
            </>
          ) : (
            <FaUser
              size={24}
              title="Login"
              onClick={() => navigate('/login')}
              style={{ cursor: 'pointer', color: '#007bff' }}
            />
          )}
        </div>

        {/* Mobile Menu Toggle (right side) */}
        <button
          className="mobile-menu-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-content">
          <div className="mobile-links">
            <NavLink to="/booking" className="mobile-link">Reservierung</NavLink>
            <NavLink to="/about" className="mobile-link">ÜBERUNS</NavLink>
            <NavLink to="/menu" className="mobile-link">SPEISEKARTE</NavLink>
            <NavLink to="/opening-hours" className="mobile-link">ÖFFNUNGSZEITEN</NavLink>
            <NavLink to="/contact" className="mobile-link">KONTAKT</NavLink>

            {/* Mobile Login/Profile */}
            <div className="mobile-login-icon mt-3">
              {isLoggedIn ? (
                <>
                  <FaUserCircle
                    size={28}
                    title={userRoles.includes('ROLE_ADMIN') ? 'Admin Dashboard' : 'User Profile'}
                    onClick={handleProfileNavigation}
                    style={{ cursor: 'pointer', color: '#dc3545', marginRight: '15px' }}
                  />
                  <FaSignOutAlt
                    size={24}
                    title="Logout"
                    onClick={handleLogout}
                    style={{ cursor: 'pointer', color: '#6c757d' }}
                  />
                </>
              ) : (
                <FaUser
                  size={24}
                  title="Login"
                  onClick={() => navigate('/login')}
                  style={{ cursor: 'pointer', color: '#007bff' }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
